import React from 'react';
import ReactDOM from 'react-dom';

import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Jumbotron from 'react-bootstrap/Jumbotron';

import PopupBox from '../PopupBox.js';

import IQRow from './IQRow.js';

import Countdown from '../Countdown.js';


export default class IQ extends React.Component {
  render() {



    //handle the click on one of the buttons
    const handleClick = (e) => {

      console.log("---clickly ", e.target.getAttribute("value"))
      
       //if the id value of the button and compare to the correct answer
       if( parseInt(e.target.getAttribute("value")) == 1)
       { 
         this.props.setResult(true, this)
       }
       else
       {
         this.props.setResult(false, this)
       }
      


    };

    function getTwoRandomMovements()
    {
      let m0 = randomMovement()
      let m1 = randomMovement()

      if(m0 != 0)
      {
        m1 = 0
      }

      return [m0, m1]
    }


    let randomMovement0 = getTwoRandomMovements()
    let randomMovement1 = getTwoRandomMovements()
    let randomMovement2 = getTwoRandomMovements()

    //instructions for each image to follow, applied each column across
    var instructions = [

        {rotate: 0, moveX: randomMovement0[0], moveY: randomMovement0[1], invert: randomInvert()},
        {rotate: 0, moveX: randomMovement1[0], moveY: randomMovement1[1], invert: randomInvert()},
        {rotate: 0, moveX: randomMovement2[0], moveY: randomMovement2[1], invert: randomInvert()},

    ]

    var images = [

        "../images/iq/square.png",
        "../images/iq/circle.png",
        "../images/iq/tick.png"

    ]


    function randomPosition()
    {
        
        return Math.floor(Math.random()*9)

    }

    function randomMovement()
    {
        
        return Math.round(Math.random()*1.8-0.9)

    }

    function randomInvert()
    {
        
        return Math.round(Math.random()*1.2)


    }

    // 3 sets of initial positrions for the 3 shapes for each row of questions.
    var initial_positions = [

        [randomPosition(),randomPosition(),randomPosition()],
        [randomPosition(),randomPosition(),randomPosition()],
        [randomPosition(),randomPosition(),randomPosition()],

    ]
    




    return (



      <PopupBox position={this.props.position} getPos={this.props.getPos} question={this}>


      <Countdown time_allowed={60} getPos={this.props.getPos} question={this} setResult={this.props.setResult}></Countdown>

     
        <h2 onClick={handleClick} className="text-danger">{this.props.question}</h2>

        
                
                <IQRow showLast={true} instructions={instructions} images={images} initial_positions={initial_positions[2]}></IQRow>
                <div className="spacer"></div>
                <div className="spacer"></div>

                
                <IQRow handleClick={handleClick} isAnswers={true} instructions={instructions} images={images} initial_positions={initial_positions[2]}></IQRow>
                

        
      

      </PopupBox>

    );
  }
}
